<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.dimensiones' | translate"
    [array]="dimensiones"
    [click]="false"
    [typeFilter]="type.ESCENARIOS"
    (eventClick)="dimensionChange($event)"
  />

  <div contenido class="spaceFloat">
    <div class="zonaSuperior w3-white">
      <div class="iconoDimension">
        <mat-icon>{{icono_dimension}}</mat-icon>
      </div>
      <div class="infoDimension">
        <div class="titulo">
          {{dimension_select}}
        </div>
        <div class="descripcionDimension">
          {{description_dimension}}
        </div>
      </div>
    </div>
    <div class="zonaInferior">
      <div class="header">
        <div class="textos">
          <div class="titulo w3-tituloPrincipal">
            {{'cues.catalogo-dimensiones.indicadores-de' | translate}} {{dimension_select}}
          </div>
          <div class="subtitulo">
            {{'cues.catalogo-dimensiones.subtitulo' | translate}}
          </div>
        </div>
        <mat-icon class="iconoMen" (click)="mostrarPreguntas = !mostrarPreguntas"
          [matTooltip]="(mostrarPreguntas ? 'cues.catalogo-dimensiones.ocultar-preguntas' : 'cues.catalogo-dimensiones.mostrar-preguntas') | translate">
          {{ mostrarPreguntas ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </div>
      <div class="body" [class.mostrarTodas]="mostrarPreguntas">
        @if (loading) {
          @for (s of skeletons; track $index) {
            <app-skeleton-card />
          }
        } @else {
          @for (tar of tarjetas; track $index) {
            <div class="cardIndicador">
              <!-- Fijo: el indicador sigue visible cuando el hover revela la pregunta -->
              <div class="encabezado">
                <div class="iconoIndicador">
                  <mat-icon>{{tar.icon}}</mat-icon>
                </div>
                <div class="tituloIndicador">
                  {{tar.title}}
                  <div class="linea"></div>
                </div>
                <div class="numero">{{ ($index + 1) < 10 ? '0' + ($index + 1) : ($index + 1) }}</div>
              </div>
              <div class="ventana">
                <div class="cortina">
                  <div class="vista">
                    <div class="cuerpo">
                      {{tar.body}}
                    </div>
                  </div>
                  <div class="vista vistaPregunta">
                    <div class="encabezado-c">
                      {{'cues.catalogo-dimensiones.pregunta-aplica' | translate}}
                    </div>
                    <div class="cuerpo-c">
                      @for (pregunta of tar.preguntas; track $index) {
                        <div class="pregunta">{{pregunta}}</div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
</app-esqueleto-tableros>